import { useState, useEffect } from 'react';
import {
  Box,
  Modal,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
} from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import {
  addPropertyTypeBankAcc,
  fetchPropertyTypeBank,
  updatePropertyTypeBank,
} from 'services/finance.service';
import { toast } from 'react-toastify';
import { yupResolver } from '@hookform/resolvers/yup';
import { ValidationSchema } from './ValidationSchema';
import { useForm } from 'react-hook-form';
import { getPropertyType } from 'services/addProperty.service';
import axios from 'axios';

const AddBankModal = ({
  fetchBankDetails,
  modalOpen,
  setModalOpen,
  updateBankModal,
  typeBankId,
}) => {
  const [modalLoading, setModalLoading] = useState(false);
  const [propertyType, setPropertyType] = useState([
    {
      propertyTypeId: 1,
      name: 'no data found',
    },
  ]);
  //handler function
  const onSubmitAddBankAcc = (val) => {
    // if (Boolean(updateBankModal && typeBankId)) {
    //   updatePropertyTypeBankDetails(val);
    // } else {
    setPropertyTypeBank(val);
    // }
  };
  const showErrorMessage = (errorMessage) => {
    return (
      <div style={{ fontSize: 'small', color: 'red' }}>
        {errorMessage.message}
      </div>
    );
  };
  //validation function for add bank
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
  } = useForm({
    mode: 'onTouched',
    resolver: yupResolver(ValidationSchema),
  });
  //API Integration
  const setPropertyTypeBank = async (body) => {
    setModalLoading(true);
    try {
      const res = await addPropertyTypeBankAcc(body);
      if (!res.isError) {
        fetchBankDetails({ page: 0, perPage: 10 });
        setModalOpen('');
        reset();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
    setModalLoading(false);
  };
  // const updatePropertyTypeBankDetails = async (body) => {
  //   setModalLoading(true);
  //   try {
  //     const res = await updatePropertyTypeBank(typeBankId, body);
  //     if (!res.isError) {
  //       fetchBankDetails({ page: 0, perPage: 10 });
  //       setModalOpen('');
  //       reset();
  //     } else {
  //       toast.error(res?.message);
  //     }
  //   } catch (error) {
  //     const { response } = error;
  //     toast.error(response?.data?.message);
  //   }
  //   setModalLoading(false);
  // };
  const fetchPropertyType = async () => {
    try {
      const propertyTypeRes = await getPropertyType();
      if (!propertyTypeRes.isError) {
        setPropertyType(propertyTypeRes.data.propertyTypes);
      } else {
        toast.error(propertyTypeRes?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
  };
  // const fetchPropertyTypeBankDetails = async (id, cancelToken) => {
  //   try {
  //     const propertyTypeRes = await fetchPropertyTypeBank(id, cancelToken);
  //     if (!propertyTypeRes.isError) {
  //       setPropertyType(propertyTypeRes.data.propertyTypes);
  //     } else {
  //       toast.error(propertyTypeRes?.message);
  //     }
  //   } catch (error) {
  //     const { response } = error;
  //     toast.error(response?.data?.message);
  //   }
  // };
  // API call
  useEffect(() => {
    fetchPropertyType();
  }, []);
  // API call
  // useEffect(() => {
  //   const source = axios.CancelToken.source();
  //   Boolean(updateBankModal && typeBankId) && fetchPropertyTypeBankDetails(typeBankId, source.token);
  //   return () => source.cancel('Component got unmounted');
  // }, []);
  return (
    <Modal
      open={modalOpen === 'Modal1'}
      onClose={() => setModalOpen('')}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
        }}
      >
        <form onSubmit={handleSubmit(onSubmitAddBankAcc)}>
          <MDTypography id="modal-modal-title" variant="h4" component="h2">
            {updateBankModal ? 'Update' : 'Add'} Property Type Bank
          </MDTypography>
          <MDBox mt={3} display="flex" flexDirection="column" gap="16px">
            <FormControl fullWidth>
              <MDInput
                name="name"
                label="Add Property Type Name"
                fullWidth
                {...register('name')}
              />
              {errors.name && showErrorMessage(errors.name)}
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="propertyType">Select Property Type</InputLabel>
              <Select
                name="propertyType"
                labelId="propertyType"
                id="property"
                sx={{ height: '44px' }}
                label="Select Property Type"
                MenuProps={{
                  style: {
                    maxHeight: '300px',
                  },
                }}
                // onChange={(e) => setPropertyType(e.target.value)}
                {...register('propertyType')}
              >
                {propertyType?.map((type, index) => {
                  return (
                    <MenuItem
                      value={type.propertyTypeId}
                      key={type.propertyTypeId}
                      selected={index === 1}
                    >
                      {type.name}
                    </MenuItem>
                  );
                })}
              </Select>
              {errors.propertyType
                ? showErrorMessage(errors.propertyType)
                : null}
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Account Type
              </InputLabel>
              <Select
                sx={{ minHeight: '48px' }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Account Type"
                {...register('bankAccountType')}
              >
                <MenuItem value="savings">Savings</MenuItem>
                <MenuItem value="checking">Checking</MenuItem>
              </Select>
              {errors.bankAccountType &&
                showErrorMessage(errors.bankAccountType)}
            </FormControl>
            <FormControl fullWidth>
              <MDInput
                label="Account Number"
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                {...register('accountNumber')}
                fullWidth
              />
              {errors.accountNumber && showErrorMessage(errors.accountNumber)}
            </FormControl>
            <FormControl fullWidth>
              <MDInput
                label="Routing Number"
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                {...register('routingNumber')}
                fullWidth
              />
              {errors.routingNumber && showErrorMessage(errors.routingNumber)}
            </FormControl>
          </MDBox>
          <MDBox align="right" marginTop="32px">
            <MDButton
              onClick={() => {
                setModalOpen(false);
                reset();
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              color="info"
              type="submit"
              isLoading={modalLoading}
              disabled={!isDirty || !isValid}
            >
              Add
            </MDButton>
          </MDBox>
        </form>
      </Box>
    </Modal>
  );
};

export default AddBankModal;
